import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@mui/material';
import InputGroupV2 from '../InputGroupV2';

const NivelSelectV2 = ({ label, onChange, value, placement, title, useTooltip, required }) => {
  return (
    <InputGroupV2
      label={label}
      placement={placement}
      title={title}
      useTooltip={useTooltip}
      isRequired={required}
    >
      <TextField
        fullWidth
        margin="dense"
        name={label.toLowerCase()}
        onChange={event => onChange(event.target.value)}
        select
        SelectProps={{ native: true }}
        value={value}
        variant="outlined"
      >
        <option key="NA" value={null}>Selecione...</option>
        <option key="BAIXO" value="BAIXO">Baixo</option>
        <option key="MEDIO" value="MEDIO">Médio</option>
        <option key="ALTO" value="ALTO">Alto</option>
      </TextField>
    </InputGroupV2>
  );
};

NivelSelectV2.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placement: PropTypes.string,
  title: PropTypes.string,
  useTooltip: PropTypes.bool,
  required: PropTypes.bool,
};

NivelSelectV2.defaultProps = {
  title: '',
  placement: 'top',
  required: false,
  useTooltip: false,
  value: '',
};

export default NivelSelectV2;
